import {
  CHANGE_LAYOUT,
  CHANGE_LAYOUT_WIDTH,
  CHANGE_SIDEBAR_THEME,
  CHANGE_BODY_THEME,
  CHANGE_SIDEBAR_TYPE,
  CHANGE_BODY_MODE,
  CHANGE_TOPBAR_THEME,
  SHOW_RIGHT_SIDEBAR,
  SHOW_SIDEBAR,
  TOGGLE_LEFTMENU,
  RESET_LAYOUT_STATE,
} from '../types/layout';

// Change Layout
export const changeLayout = (layout) => ({
  type: CHANGE_LAYOUT,
  payload: layout,
});

// Change Layout Width
export const changeLayoutWidth = (width) => ({
  type: CHANGE_LAYOUT_WIDTH,
  payload: width,
});

// Change Sidebar Theme
export const changeSidebarTheme = (theme) => ({
  type: CHANGE_SIDEBAR_THEME,
  payload: theme,
});

// Change Body Theme
export const changeBodyTheme = (theme) => ({
  type: CHANGE_BODY_THEME,
  payload: theme,
});

// Change Body Mode
export const changeBodyMode = (mode) => ({
  type: CHANGE_BODY_MODE,
  payload: mode,
});

// Change Sidebar Type
export const changeSidebarType = (sidebarType, isMobile = false) => ({
  type: CHANGE_SIDEBAR_TYPE,
  payload: { sidebarType, isMobile },
});

// Change Topbar Theme
export const changeTopbarTheme = (topbarTheme) => ({
  type: CHANGE_TOPBAR_THEME,
  payload: topbarTheme,
});

// Show Right Sidebar
export const showRightSidebarAction = (isOpen) => ({
  type: SHOW_RIGHT_SIDEBAR,
  payload: isOpen,
});

// Show Sidebar
export const showSidebar = (isOpen) => ({
  type: SHOW_SIDEBAR,
  payload: isOpen,
});

// Toggle Left Menu
export const toggleLeftmenu = (isOpen) => ({
  type: TOGGLE_LEFTMENU,
  payload: isOpen,
});

// Reset Layout State
export const resetLayoutState = () => ({
  type: RESET_LAYOUT_STATE,
});
